import {
  messageId,
  PropertyMeta,
  ValueObjectMetaNumber,
} from "@pscsrvlab/psc-react-components";
import { z } from "zod";
const minimalSchema = z.number().min(1);
const savedMinimalSchema = z.number().min(1);
const schema = z.number().min(1);
const savedSchema = z.number().min(1);
const jsonSchema = z.number();
/**
 * 細胞番号(値オブジェクト)のメタデータ。
 *
 *  */
export const cellNumberMeta = new ValueObjectMetaNumber(
  "CellNumber",
  "\u7D30\u80DE\u756A\u53F7",
  messageId("lbl.\u7D30\u80DE\u756A\u53F7"),
  minimalSchema,
  schema,
  jsonSchema,
  undefined,
  undefined
);
